import { Box, Stack } from '@mui/material';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { FreightOrigin } from '../../../../../../../conditions/orderCondition.types';
import OrderConditionFreightOriginIndicator from '../../OrderConditionFreightOriginIndicator';
import OrderConditionReadOnlyField from '../../OrderConditionReadOnlyField';
import { getConditionFieldsGridSx } from '../../orderConditionDetails.utils';

interface OrderConditionReadOnlyDeliverySectionProps {
  deliveryAddressValue?: string;
  shippingCostValue?: string;
  freightCompanyValue?: string;
  freightModalityValue?: string;
  freightTermValue?: string;
  freightOrigin?: FreightOrigin;
  isFreightVisible: boolean;
  containerWidth: number;
}

const OrderConditionReadOnlyDeliverySection = ({
  deliveryAddressValue,
  shippingCostValue,
  freightCompanyValue,
  freightModalityValue,
  freightTermValue,
  freightOrigin,
  isFreightVisible,
  containerWidth,
}: OrderConditionReadOnlyDeliverySectionProps) => {
  const gridSx = getConditionFieldsGridSx(true, containerWidth);

  return (
    <Stack sx={{ gap: 2 }}>
      <OrderConditionReadOnlyField
        label={LangEnum.ORDER_CONDITIONS_DELIVERY_ADDRESS_LABEL}
        value={deliveryAddressValue}
      />

      {isFreightVisible && (
        <>
          <Box sx={gridSx}>
            <OrderConditionReadOnlyField
              label={LangEnum.GLOBAL_SHIPPING_COMPANY}
              value={freightCompanyValue}
            />
            <OrderConditionReadOnlyField
              label={LangEnum.GLOBAL_SHIPPING_MODALITY}
              value={freightModalityValue}
            />
          </Box>

          <Box sx={gridSx}>
            <OrderConditionReadOnlyField
              label={LangEnum.GLOBAL_DELIVERY_TERM}
              value={freightTermValue}
            />
            <OrderConditionReadOnlyField
              label={LangEnum.GLOBAL_SHIPPING_COST}
              value={shippingCostValue}
              adornment={
                freightOrigin && <OrderConditionFreightOriginIndicator origin={freightOrigin} />
              }
            />
          </Box>
        </>
      )}
    </Stack>
  );
};

export default OrderConditionReadOnlyDeliverySection;
